import React from "react";

const IlluminateText = ({ text }) => {
  return <span className="transition-all duration-100 ease-linear text-green-500 hover:cursor-pointer hover:drop-shadow-[0px_15px_20px_rgba(34,197,94,0.5)]">{ text }</span>;
};

export default IlluminateText;
